import React, { Component } from 'react'
import {makeStyles} from '@material-ui/core/styles';
import Drawer           from '@material-ui/core/Drawer';
import List             from '@material-ui/core/List';
import ListItem         from '@material-ui/core/ListItem';
import ListItemText     from '@material-ui/core/ListItemText';
import CssBaseline      from '@material-ui/core/CssBaseline';
import clsx             from 'clsx';
import Card             from '@material-ui/core/Card';
import Grid             from '@material-ui/core/Grid';
import ColAtm           from "../../../atomic/Col/Col";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {dashboardPropertyActions} from "../../../../redux/actions/dasboardActions";
import 'react-circular-progressbar/dist/styles.css';
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import Container from "@material-ui/core/Container";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import {userMenu} from "../../../../redux/actions/menuActions";
import {Link} from "react-router-dom";
import 'pure-react-carousel/dist/react-carousel.es.css';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import {Hidden} from "@material-ui/core";
import {
    APP,
    BOOKING_ENGINE, CONTENT,
    NETWORK, NETWORK_COMPETITOR, NOT_ALLOWED_DASHBOARD_SHORT,
    OFFER,
    PAYMENT,
    WEB,
    REPUTATION_MANAGEMENT,
    NETWORK_COMPETITOR_DASH
} from "../../../../constants/appUrls.constants";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import {history} from "../../../../utils/history";
import {getPropertyName, isDefined} from "../../../../utils";
import {propertyProducts} from "../../../../redux/actions/propertyProductsActions";
import NotAllowedPage from "./NotAllowedPage";
import Charts from "../Charts";
import {Box, Typography} from '@material-ui/core';

const drawerWidth = 91;
const drawerWidthCollapsed = 280;
const drawerWidthExpanded = 280;
const leftMenuWidth = 252;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    leftMenu: {
        width: 0,
        flexShrink: 0,
    },
    leftMenuPaper: {
        width: leftMenuWidth,
        marginLeft: 102,
        marginTop: 81
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '&:hover': {
            width: drawerWidthExpanded,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#475569',
        marginLeft: 24,
        opacity: 1,
        transform: 'translateX(-10px)',
        transition: 'opacity 0.25s ease, transform 0.25s ease',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // '$drawerPaper:hover &': {
        //     opacity: 1,
        //     transform: 'translateX(0)',
        // },
    },
    sidebarTextActive: {
        color: '#fff',
    },
    sidebarDivider: {
        height: 1,
        background: '#e2e8f0',
        margin: '10px 8px',
        transition: 'margin 0.3s ease',
        '$drawerPaper:hover &': {
            margin: '10px 12px',
        },
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        marginTop: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftBarShift: {
        width: `calc(100% - ${leftMenuWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: '11px 12.14px'
    },
    hide: {
        display: 'none',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 125,
        marginRight: -60,
        paddingRight: 120,
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
}));

class NotPurchasedDashboard extends Component{
    componentDidMount() {
        document.body.style.backgroundColor = "#f4f7fc";
        const {dashboardPropertyActions, userMenu, propertyProducts} = this.props;
        dashboardPropertyActions();
        userMenu();
        propertyProducts();
    }

    render(){
        const dashboard = this.props.property_dashboard;
        const leftDrawer = this.props.left_drawer;
        const { t } = this.props;

        const allowedPageNetwork = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageOffer = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageWeb = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "web" === item.route)

        const allowedPageBookingEngine = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPagePayment = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        const allowedPageReputationManagement = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route)

        function Dashboard(props) {
            const classes = useStyles();

            function Sidebar(props) {
                const sidebar = (
                    <div className={classes.root}>
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            <List className={classes.sidebarList}>
                                {props.siderbarItems.map((post, key) => (
                                    <React.Fragment key={key}>
                                        <Link 
                                            to={post.link} 
                                            className={classes.sidebarLink}
                                        >
                                            <Box 
                                                className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                            >
                                                <Box className={classes.sidebarIconWrapper}>
                                                    <i 
                                                        className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                    />
                                                </Box>
                                                <Typography 
                                                    className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''}`}
                                                >
                                                    {post.text}
                                                </Typography>
                                            </Box>
                                        </Link>
                                        {/* {(key === 0 || key === 3) && (
                                            <Box className={classes.sidebarDivider} />
                                        )} */}
                                    </React.Fragment>
                                ))}
                            </List>
                            <Box className={classes.chartsWrapper}>
                                <Charts />
                            </Box>
                        </Drawer>
                    </div>
                );
                return (
                    <>
                        {sidebar}
                    </>
                );
            }

            const siderbarItems = [
                {id: 1, isActive: props.lastUrl === "content" ? true : false, text:  `${ t('enw-product_one-title') }`, icon: 'fas fa-hotel', link:CONTENT},
                {id: 4, isActive: props.lastUrl === "web" ? true : false, text: `${t('enw-product_four-title') }`, icon: 'fas fa-network-wired', link: isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB :  NOT_ALLOWED_DASHBOARD_SHORT + "/web" },
                {id: 5, isActive: props.lastUrl === "booking-engine" ? true : false, text: `${t('enw-product_six-title')}`, icon: 'fas fa-calendar-alt', link: isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE :  NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" },
                {id: 6, isActive: props.lastUrl === "payment" ? true : false, text: `${t('enw-product_five-title') }`, icon: 'fas fa-money-bill-wave-alt', link: isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? PAYMENT :  NOT_ALLOWED_DASHBOARD_SHORT + "/payment" },
                {id: 3, isActive: props.lastUrl === "offer" ? true : false, text: `${t('enw-product_three-title') }`, icon: 'fas fa-paperclip', link: isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" },
                {id: 2, isActive: props.lastUrl === "network" ? true : false, text: `${t('enw-product_two-title') }`, icon: 'fas fa-chart-network', link: isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" },
                {id: 7, isActive: false, text: (
                    <>
                        {t('enw-input-competitor')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
                ), icon: 'fas fa-analytics', link: isDefined(propertyProductCompetitor[0]) && propertyProductCompetitor[0].property_has_product ? NETWORK_COMPETITOR_DASH : NOT_ALLOWED_DASHBOARD_SHORT + "/competitor-analysis"  },
                {id: 8, isActive: props.lastUrl === "reputation-management" ? true : false, text: (
                    <>
                        {t('enw-reputation_management-title')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
                ), icon: 'fas fa-comments-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#" },
            ];

            return (
                <ColAtm>
                    <Hidden smDown>
                        <ColAtm md={1} style={{ height: 'fit-content'}}>
                            <Sidebar siderbarItems={siderbarItems} />
                        </ColAtm>
                    </Hidden>
                    <ColAtm sm={8} md={11} className="m-auto">
                        <div className={classes.root}>
                            <CssBaseline />
                            <main
                                className={clsx("dashboard-content")}
                            >
                                <div className={classes.drawerHeader} />
                                <div className={classes.root}>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} lg={11}>
                                            <Hidden xsDown>
                                                <Card className="p-24 no-buy-product-content">
                                                    <NotAllowedPage />
                                                    <Carousel>
                                                    </Carousel>
                                                </Card>
                                            </Hidden>
                                            <Hidden smUp>
                                                <Card className="p-24 no-shadow">
                                                    <NotAllowedPage />
                                                    <Carousel>
                                                    </Carousel>
                                                </Card>
                                            </Hidden>
                                        </Grid>
                                    </Grid>
                                </div>
                            </main>
                        </div>
                    </ColAtm>
                    <style>{`
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top:5px !important;
                        }
                    }
                    .MuiDrawer-paper::-webkit-scrollbar {
                        width: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb {
                        background: #d1d5db;
                        border-radius: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
                        background: #9ca3af;
                    }

                    @media (min-width: 960px) and (max-width: 1600px) {
                        .MuiDrawer-paper {
                            height: calc(125vh - 81px) !important;
                            min-height: calc(125vh - 101px) !important;
                        }
                        
                        .sidebar-items, .active-sidebar {
                            padding: 10px 14px !important;
                        }
                        
                        .sidebar-items i,
                        .active-sidebar i {
                            font-size: 16px !important;
                        }
                        
                        .dashboard-menu {
                            font-size: 12px !important;
                        }
                    }

                    .MuiDrawer-paper {
                        &:hover {
                            .sidebar-text-animated {
                                opacity: 1 !important;
                                transform: translateX(0) !important;
                            }
                        }
                    }
                    @media (min-width: 1300px) {
                        .be-container-width, .dashboard-content {
                            padding: 0px 0px 0px 150px !important;
                        }
                    }
                    .no-buy-product-content {
                        margin: 7% 42px !important;
                    }
                `}</style>
                </ColAtm>
            );
        }


        return(
            <>
                <PageTitle title={ t('enw-dashboard-page_title') } />
                <PageHeaderAtm exitText={ t('btn-properties') } backButton={APP} text={ getPropertyName() } />
                <Container maxWidth="xl">
                    <div className="dashboard-width">
                        <Dashboard
                            dashboard={dashboard}
                            leftDrawer={leftDrawer}
                            propertyProductsReducer={this.props.propertyProductsReducer}
                            lastUrl={this.props.match.params.id}
                        />
                    </div>
                </Container>
                <Hidden mdUp>
                    <BottomNavigation className="m-navigation" value={this.props.match.params.id}>
                        <BottomNavigationAction value="content" icon={<i className="fas fa-hotel" />} onClick={() => { history.push(CONTENT)}}  />
                        <BottomNavigationAction value="web" icon={<i className="fas fa-network-wired" />} onClick={() => { history.push(isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB :  NOT_ALLOWED_DASHBOARD_SHORT + "/web")}} />
                        <BottomNavigationAction value="booking-engine" icon={<i className="fas fa-calendar-alt" />} onClick={() => { history.push(isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE :  NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine")}} />
                        <BottomNavigationAction value="payment" icon={<i className="fas fa-money-bill-wave-alt" />} onClick={() => { history.push(isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? PAYMENT :  NOT_ALLOWED_DASHBOARD_SHORT + "/payment")}} />
                        <BottomNavigationAction value="offer" icon={<i className="fas fa-paperclip" />} onClick={() => { history.push(isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer")}} />
                        <BottomNavigationAction value="network" icon={<i className="fas fa-chart-network" />} onClick={() => { history.push(isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" )}} />
                        <BottomNavigationAction value="competitor-analysis" icon={<i className="fas fa-analytics" />} onClick={() => { history.push(NETWORK_COMPETITOR_DASH) }} />
                        <BottomNavigationAction
                            value="reputation-management"
                            icon={<i className="fas fa-comments-alt" />}
                            onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#")}}
                        />
                    </BottomNavigation>
                </Hidden>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        propertyProductsReducer : state.propertyProductsReducer
    }
};

export default compose(withTranslation('common')) (connect(mapStateToProps, {dashboardPropertyActions, userMenu, propertyProducts})(NotPurchasedDashboard));
